import React from 'react'
import { Flex } from '@chakra-ui/react'

import MessageText from './text'
import MessageBubble from './bubble'
import MessageName from './message-name'
import MessageAttachments from './attachments'
import MessageDetailsInfo from './message-info'
import PlacementWrapper from './placement-wrapper'
import { useMessageProperties } from '../message-provider'
import SharedStack from '~components/shared/wrappers/shared-stack'
import MessageErrors from '../message-errors'
import { MessageLocationTag } from '../index'
import MessageActions from '../../message-actions'

export default function UserMessage({
    showLocationTag,
}: {
    showLocationTag?: boolean
}) {
    const { isCurrentUser, noTail, noHead, message, chat } =
        useMessageProperties()

    return (
        <PlacementWrapper>
            <MessageBubble
                isRight={!!isCurrentUser}
                isLast={!noTail}
                isFirst={!noHead}
                showLocationTag={showLocationTag}
            >
                <Flex flexDir="row" align="center" justify="space-between">
                    <SharedStack row fit>
                        <MessageName />
                        {showLocationTag && <MessageLocationTag />}
                    </SharedStack>
                    <SharedStack row fit>
                        <MessageErrors />
                        {!showLocationTag && (
                            <MessageActions message={message} chat={chat} />
                        )}
                    </SharedStack>
                </Flex>
                <MessageText />
                <MessageAttachments />
                <MessageDetailsInfo />
            </MessageBubble>
        </PlacementWrapper>
    )
}
